import $ from 'jquery';
import BlogLayout from '../snippets/BlogLayout';

export default class SearchStaticSection {
  constructor(section) {
    // Tabs
    this.$tabs = $('.search-results-tab', section.el);
    this.$groups = $('.search-results-group', section.el);

    // Article results
    this.$articles = $('[data-article-excerpts]', section.el);
    this.blogLayout = new BlogLayout(this.$articles);

    // Events
    this.events = [
      this.$tabs.on('click.search', event => {
        event.preventDefault();
        this._selectTab(event.currentTarget);
      }),
    ];

    // Init state
    this.$tabs.first().click();
  }

  onSectionUnload() {
    this.blogLayout.unload();
    this.events.forEach($el => $el.off('.search'));
  }

  _selectTab(el) {
    const $el = $(el);

    // Select tab
    this.$tabs.removeClass('search-results-tab-selected');
    $el.addClass('search-results-tab-selected');

    // Select group
    this.$groups.removeClass('search-results-group-selected');
    const selector = $el.attr('href');
    $(selector).addClass('search-results-group-selected');

    // Re-layout blog posts
    this.blogLayout.update();
  }
}
